<div class="page-header">
  @if (breadcrumbs && breadcrumbs.length) {
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        @for (crumb of breadcrumbs; track crumb; let last = $last) {
          <li class="breadcrumb-item" [class.active]="last">
            @if (!last) {
              <a [routerLink]="crumb.link"
                ><i [class]="crumb.icon"></i>{{ crumb.label }}</a
                >
              } @else {
                <i [class]="crumb.icon"></i> {{ crumb.label }}
              }
            </li>
          }
        </ol>
      </nav>
    }

    <div class="container-header" [class.container-header--no-wrap]="!headerFlexWrap">
      <div class="title-container">
        <h1 class="page-title">@if (titleIcon) {
          <i [class]="titleIcon"></i>
        }{{ title }}</h1>
        @if (subtitle) {
          <p class="page-subtitle">{{ subtitle }}</p>
        }
      </div>
      <div class="dynamic-container">
        <!-- A área onde o conteúdo será projetado -->
        <ng-content></ng-content>
      </div>
    </div>
  </div>
